import React from "react";
import {
  Box,
  FormControlLabel,
  Checkbox,
  Typography,
  Link,
} from "@mui/material";
import ArticleRoundedIcon from "@mui/icons-material/ArticleRounded";
import { StepContent } from "../../styles/StyledComponents";

const Step4Questionario = ({ formData, handleInputChange }) => {
  return (
    <StepContent>
      <Box sx={{ textAlign: "center", mb: 4 }}>
        <Box
          sx={{
            width: 80,
            height: 80,
            borderRadius: "50%",
            background: "linear-gradient(135deg, #1976d2, #42a5f5)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            margin: "0 auto",
            mb: 2,
          }}
        >
          <ArticleRoundedIcon sx={{ fontSize: 40, color: "white" }} />
        </Box>
      </Box>

      {/* Consapevolezza Copertura */}
      <Box
        sx={{
          borderLeft: (theme) =>
            `4px solid ${
              theme.palette.mode === "light" ? "#1976d2" : "#42a5f5"
            }`,
          backgroundColor: (theme) =>
            theme.palette.mode === "light"
              ? "#e3f2fd"
              : "rgba(25, 118, 210, 0.1)",
          borderRadius: 1,
          p: 3,
          mb: 3,
        }}
      >
        <Typography
          variant="h6"
          sx={{ fontWeight: 600, mb: 2, color: "#1976d2" }}
        >
          Consapevolezza Copertura
        </Typography>

        <FormControlLabel
          control={
            <Checkbox
              checked={formData.consapevolezzaScoperti}
              onChange={handleInputChange("consapevolezzaScoperti")}
              sx={{
                color: "#ff9800",
                "&.Mui-checked": { color: "#ff6f00" },
              }}
            />
          }
          label={
            <Typography variant="body2">
              Sei consapevole della possibile presenza di{" "}
              <strong>
                Scoperti, Franchigie, Carenze, Limiti ed Esclusioni
              </strong>{" "}
              e questi risultano in linea con le tue esigenze? *
            </Typography>
          }
          sx={{ mb: 2, alignItems: "center" }}
        />

        <FormControlLabel
          control={
            <Checkbox
              checked={formData.comprensioneRinnovo}
              onChange={handleInputChange("comprensioneRinnovo")}
              sx={{
                color: "#ff9800",
                "&.Mui-checked": { color: "#ff6f00" },
              }}
            />
          }
          label={
            <Typography variant="body2">
              Hai compreso che il contratto{" "}
              <strong>
                NON potrà essere rinnovato oltre 5 anni consecutivi
              </strong>
              ? *
            </Typography>
          }
          sx={{ alignItems: "center" }}
        />
      </Box>

      {/* Tipo di Protezione Desiderata */}
      <Box
        sx={{
          borderLeft: (theme) =>
            `4px solid ${
              theme.palette.mode === "light" ? "#ff9800" : "#ffb74d"
            }`,
          backgroundColor: (theme) =>
            theme.palette.mode === "light"
              ? "#fff8e1"
              : "rgba(255, 152, 0, 0.1)",
          borderRadius: 1,
          p: 3,
          mb: 3,
        }}
      >
        <Typography
          variant="h6"
          sx={{ fontWeight: 600, mb: 1, color: "#ff9800" }}
        >
          Tipo di Protezione Desiderata *
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          (Scegli una o entrambe)
        </Typography>

        <FormControlLabel
          control={
            <Checkbox
              checked={formData.protezioneStandard}
              onChange={handleInputChange("protezioneStandard")}
              sx={{
                color: "#ff9800",
                "&.Mui-checked": { color: "#ff6f00" },
              }}
            />
          }
          label={
            <Typography variant="body2">
              <strong>Protezione Standard:</strong> Contro eventi imprevisti
              (infortunio, malattia) con pagamento capitale assicurato o
              indennità mensili
            </Typography>
          }
          sx={{ mb: 2, alignItems: "center" }}
        />

        <FormControlLabel
          control={
            <Checkbox
              checked={formData.protezionePotenziata}
              onChange={handleInputChange("protezionePotenziata")}
              sx={{
                color: "#ff9800",
                "&.Mui-checked": { color: "#ff6f00" },
              }}
            />
          }
          label={
            <Typography variant="body2">
              <strong>Protezione Potenziata:</strong> Protezione superiore al
              capitale assicurato (prestazione potenziata)
            </Typography>
          }
          sx={{ alignItems: "center" }}
        />
      </Box>

      {/* Accettazioni Finali */}
      <Box sx={{ mb: 3 }}>
        <Typography
          variant="h6"
          sx={{ fontWeight: 600, mb: 2, color: "text.primary" }}
        >
          Accettazioni Finali
        </Typography>

        <FormControlLabel
          control={
            <Checkbox
              checked={formData.condizioniGenerali}
              onChange={handleInputChange("condizioniGenerali")}
              sx={{
                color: "#ff9800",
                "&.Mui-checked": { color: "#ff6f00" },
              }}
            />
          }
          label={
            <Typography variant="body2">
              Ho letto e comprendo le{" "}
              <Link href="#" underline="always" sx={{ fontWeight: 600 }}>
                Condizioni Generali della Polizza
              </Link>{" "}
              *
            </Typography>
          }
          sx={{ mb: 2, alignItems: "center" }}
        />

        <FormControlLabel
          control={
            <Checkbox
              checked={formData.condizioniVendita}
              onChange={handleInputChange("condizioniVendita")}
              sx={{
                color: "#ff9800",
                "&.Mui-checked": { color: "#ff6f00" },
              }}
            />
          }
          label={
            <Typography variant="body2">
              Accetto le{" "}
              <Link href="#" underline="always" sx={{ fontWeight: 600 }}>
                Condizioni di Vendita
              </Link>{" "}
              e{" "}
              <Link href="#" underline="always" sx={{ fontWeight: 600 }}>
                Privacy Policy
              </Link>{" "}
              *
            </Typography>
          }
          sx={{ mb: 2, alignItems: "center" }}
        />

        <FormControlLabel
          control={
            <Checkbox
              checked={formData.comunicazioniCommerciali}
              onChange={handleInputChange("comunicazioniCommerciali")}
              sx={{
                color: "#ff9800",
                "&.Mui-checked": { color: "#ff6f00" },
              }}
            />
          }
          label={
            <Typography variant="body2">
              Accetto di ricevere comunicazioni commerciali via email
            </Typography>
          }
          sx={{ alignItems: "center" }}
        />
      </Box>
    </StepContent>
  );
};

export default Step4Questionario;
